import React from "react";
import { LABEL_CARD_TYPE } from "../../../../../src/shared/canvasConstants";
import { Container } from "./styles";
import SVG from "react-inlinesvg";

export default ({ addCard, addOutlineGroup }) => {
  return (
    <Container>
      <div className="new">
        <a
          onClick={(e) => addCard({ autoHeight: true })}
          className="area"
        >
          <div className="symbol">+</div>
          <div className="text">Card</div>
        </a>

        <a
          onClick={(e) =>
            addCard({
              type: LABEL_CARD_TYPE,
              autoHeight: true,
              width: 400,
            })
          }
          className="area label"
        >
          <div className="symbol">
            <span>Aa</span>
          </div>
          <div className="text">Label</div>
        </a>

        <a onClick={(e) => addOutlineGroup()} className="area">
          <div className="symbol">
            <SVG src="/assets/canvas-outline-icon.svg" />
          </div>
          <div className="text">Outline</div>
        </a>
      </div>
    </Container>
  );
};
